const MOBILE_QUERY = '(max-width: 749px)';

function isMobile() {
  return window.matchMedia(MOBILE_QUERY).matches;
}

function modalComponentFrom(target) {
  if (!(target instanceof Element)) return null;
  const component = target.closest('[data-coutureia-bff-search="true"][data-testid="search-component--modal"]');
  if (!(component instanceof HTMLElement)) return null;
  const dialog = component.closest('#search-modal');
  return dialog instanceof HTMLElement ? dialog : null;
}

function closeOwningDialog(target) {
  if (!isMobile()) return;
  const owner = modalComponentFrom(target);
  if (!owner || typeof owner.closeDialog !== 'function') return;
  const dialog = owner.querySelector('dialog');
  if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;
  void owner.closeDialog();
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.matches('[data-coutureia-bff-search="true"] form[role="search"]')) return;
  closeOwningDialog(form);
}, true);

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const action = target.closest('[data-coutureia-action-index]');
  if (!(action instanceof HTMLElement)) return;
  if (!action.closest('[data-coutureia-bff-search="true"][data-testid="search-component--modal"]')) return;
  closeOwningDialog(action);
}, true);
